import {
  useGetComposioToolkitCatalog,
  useGetComposioToolkits,
  useGetOpenConnectorCatalog,
} from 'features/chat/agent-chat-module/hooks/use-gpt-chat';
import type { ITool } from 'features/chat/agent-chat-module/services/gpt-chat.service';
import { resolveToolProviderIcon } from 'pages/agents/utils/agent-tool-provider-icons';
import {
  catalogLogoForTool,
  connectorCatalogLogo,
  openCatalogIcon,
  openConnectorSlug,
} from './components/catalog-tool-logo';
import { resolveComposioToolLogo } from './components/composio-logos';
import { getComposioConfig } from './components/tool-detail-utils';

/** Logo for a Composio or open connector tool. Null for other tool types. */
export function useConnectorToolLogo(tool: ITool): string | null {
  const isOpenConnector = tool.type === 'open_connector';
  const isComposio = tool.type === 'composio';
  const fromConfig = isOpenConnector
    ? openConnectorSlug(tool)
    : (getComposioConfig(tool).toolkits[0] ?? '');
  const { data: catalog } = useGetComposioToolkitCatalog({
    enabled: isComposio || isOpenConnector,
  });
  // Notion's icon is on this catalog. The Composio toolkit list does not have it.
  const { data: openCatalog } = useGetOpenConnectorCatalog(undefined, {
    enabled: isOpenConnector,
    limit: 200,
  });
  const toolkitsQuery = useGetComposioToolkits(tool.id, { enabled: isComposio && !fromConfig });
  const toolkitSlug = fromConfig || toolkitsQuery.data?.toolkits?.[0]?.toolkit || '';
  const toolkits = catalog?.toolkits ?? [];

  if (isOpenConnector) {
    return (
      connectorCatalogLogo(tool, toolkits, toolkitSlug) ||
      openCatalogIcon(openCatalog?.services, toolkitSlug || tool.name) ||
      resolveToolProviderIcon(toolkitSlug || tool.name)
    );
  }
  if (!isComposio) return null;
  return (
    catalogLogoForTool(tool, toolkits, toolkitSlug) ||
    resolveComposioToolLogo(toolkitSlug, tool.description, tool.name)
  );
}
